type GridBreakpointProps = {
    forceSmallBreakpoint?: boolean;
    [key: string]: unknown;
};

const LARGE_BREAKPOINT_KEYS = ['md', 'mdOffset', 'lg', 'lgOffset', 'xl', 'xlOffset'];

export const getCompactGridBreakpoints = ({ forceSmallBreakpoint, ...breakpoints }: GridBreakpointProps) => {
    if (!forceSmallBreakpoint) return breakpoints;

    return Object.fromEntries(Object.entries(breakpoints).filter(([key]) => !LARGE_BREAKPOINT_KEYS.includes(key)));
};
